import React from 'react';
import { cn } from '../../utils/cn';

const Input = React.forwardRef(({
  className,
  type = 'text',
  error,
  label,
  helperText,
  hasLeftIcon = false,
  hasRightIcon = false,
  icon: IconComponent,
  rightIcon,
  ...props
}, ref) => {
  const showLeftIcon = hasLeftIcon || !!IconComponent;
  const showRightIcon = hasRightIcon || !!rightIcon;

  return (
    <div className="w-full">
      {label && (
        <label className="form-label mb-2 block">
          {label}
        </label>
      )}
      <div className="relative">
        {IconComponent && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none text-gray-400">
            <IconComponent className="w-5 h-5" />
          </div>
        )}
        <input
          type={type}
          className={cn(
            'form-input w-full',
            showLeftIcon && 'pl-14',
            showRightIcon && 'pr-12',
            error && 'border-red-500 focus:border-red-500 focus:ring-red-500',
            className
          )}
          style={{
            paddingLeft: showLeftIcon ? '3.5rem' : undefined,
            paddingRight: showRightIcon ? '3rem' : undefined,
          }}
          ref={ref}
          {...props}
        />
        {rightIcon && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-auto">
            {rightIcon}
          </div>
        )}
      </div>
      {(error || helperText) && (
        <p className={cn(
          'mt-1 text-sm',
          error ? 'text-red-600' : 'text-gray-500'
        )}>
          {error || helperText}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;